module.exports = __webpack_public_path__ + "media/social-media/icon-whatsapp--blue-2418a2f2.svg";